import React from "react";
import { useParams } from "react-router";
import { IframeComponent } from "../../components/IframeComponent";
import { getCookie } from "../../utils/cookie";
import { editorUrl } from "../../config";

export const EditorPage = () => {
  const { id } = useParams();
  const token = getCookie("dynos_plus_session");
  return (
    <IframeComponent
      src={`${editorUrl}/dynos/edit/${id}/?mode=edit&dynosplus=true&token=${token}`}
      title="Dynos Editor"
    />
  );
};
